import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { View } from "react-native";
var Screens;
try {
    Screens = require("react-native-screens");
} catch (e) {
// Ignore
}
export var MaybeScreenContainer = function(_param) {
    var enabled = _param.enabled, rest = _object_without_properties(_param, [
        "enabled"
    ]);
    if (Screens != null) {
        return /*#__PURE__*/ _jsx(Screens.ScreenContainer, _object_spread({
            enabled: enabled
        }, rest));
    }
    return /*#__PURE__*/ _jsx(View, _object_spread({}, rest));
};
export var MaybeScreen = function(_param) {
    var enabled = _param.enabled, active = _param.active, rest = _object_without_properties(_param, [
        "enabled",
        "active"
    ]);
    if (Screens != null) {
        return /*#__PURE__*/ _jsx(Screens.Screen, _object_spread({
            enabled: enabled,
            activityState: active
        }, rest));
    }
    return /*#__PURE__*/ _jsx(View, _object_spread({}, rest));
};
